import React from "react";
import { motion } from "framer-motion";
import { Bot, Shield, Zap, GitBranch, Layers, Clock } from "lucide-react";

const services = [
  {
    icon: Bot,
    title: "AI Test Generation",
    desc: "Automatically generate comprehensive test cases from your application flows.",
  },
  {
    icon: Shield,
    title: "Quality Assurance Consulting",
    desc: "Expert guidance to build robust QA processes tailored to your team.",
  },
  {
    icon: Zap,
    title: "Test Automation",
    desc: "Accelerate releases with automated regression and smoke testing suites.",
  },
  {
    icon: GitBranch,
    title: "Execution Plans & Launches",
    desc: "Define execution plans with variables and run coordinated test launches with clear status and results.",
  },
  {
    icon: Layers,
    title: "Custom Reporting",
    desc: "Tailored dashboards and reports aligned with your business KPIs.",
  },
  {
    icon: Clock,
    title: "24/7 Test Monitoring",
    desc: "Continuous monitoring with instant alerts on test failures and regressions.",
  },
];

const Services = () => {
  return (
    <section
      id="services"
      className="section-padding section-divider relative overflow-hidden bg-white"
    >
      <div className="absolute inset-0 bg-white/20" />
      <div className="absolute inset-0 grid-pattern opacity-[0.12]" />

      <div className="container mx-auto relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <span className="inline-flex items-center gap-2 text-[11px] font-semibold tracking-[0.2em] uppercase text-primary/90 mb-5 border border-primary/15 rounded-full px-4 py-1.5 bg-primary/5">
            Services
          </span>
          <h2 className="text-3xl md:text-5xl font-display font-bold mb-5 tracking-[-0.02em]">
            Everything your QA needs
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto leading-relaxed font-light">
            Test case management, AI generation, automated execution, and results — all in one place.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {services.map((service, i) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.06 }}
              className="group glass rounded-2xl p-8 card-hover"
            >
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors duration-500">
                <service.icon className="text-primary" size={21} />
              </div>
              <h3 className="font-display font-semibold text-lg mb-2.5 tracking-tight group-hover:text-primary transition-colors duration-300">
                {service.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {service.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
 